import { Download } from "lucide-react";
import { Api } from "../../lib/api";

export default function QrTicket({ bookingId }) {
  return (
    <div className="mt-8 card p-6 text-center" data-testid="qr-ticket">
      <p className="eyebrow">Your ticket</p>
      <img
        src={Api.ticketQrUrl(bookingId)}
        alt="Ticket QR"
        className="w-56 h-56 mx-auto mt-3"
      />
      <p className="text-xs text-grey mt-3 break-all">Booking ID: {bookingId}</p>
      <a
        href={Api.ticketQrUrl(bookingId)}
        download={`picnic-ticket-${bookingId}.png`}
        className="btn-primary mt-4"
        data-testid="download-qr-btn"
      >
        <Download size={16} /> Save ticket
      </a>
    </div>
  );
}
